import React, {useCallback, useEffect} from 'react';
import ViewSingleBatchReceiptProperties from "./ViewSingleBatchReceiptProperties";
import {Observer} from "mobx-react-lite";
import { Config } from '../../../../util/Config';
import DocumentViewer from '../../../../ui_components/DocumentViewer/DocumentViewer';

const ViewSingleBatchReceipt: React.FC<ViewSingleBatchReceiptProperties> = ({
                                                                      productOrderIds,
                                                                  }) => {
    const getInvoiceUrl = useCallback(() => {
        return Config.get("VIEW_BATCH_RECEIPT_URL", {ids: productOrderIds});
    }, [productOrderIds]);

    const [invoiceUrl, setInvoiceUrl] = React.useState(getInvoiceUrl());

    useEffect(() => {
        setInvoiceUrl(getInvoiceUrl());
    }, [productOrderIds, getInvoiceUrl]);

    return <Observer>
        {() => (
            <>
                <DocumentViewer url={invoiceUrl}/>
            </>
        )}
    </Observer>
}

export default ViewSingleBatchReceipt;
